{
  "LOGIN": {
    "TITLE": "Entrar no Chatwoot",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "Empresa{'@'}suaempresa.com.br",
      "ERROR": "Por favor, insira um endereço de e-mail válido"
    },
    "PASSWORD": {
      "LABEL": "Palavra-passe",
      "PLACEHOLDER": "Palavra-passe"
    },
    "API": {
      "SUCCESS_MESSAGE": "Login bem-sucedido",
      "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot. Por favor, tente novamente.",
      "UNAUTH": "E-mail ou palavra-passe incorretos. Por favor, tente novamente."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Iniciar sessão com o Google",
      "BUSINESS_ACCOUNTS_ONLY": "Por favor, use o endereço de e-mail da empresa para iniciar sessão",
      "NO_ACCOUNT_FOUND": "Não conseguimos encontrar uma conta com o seu endereço de e-mail."
    },
    "FORGOT_PASSWORD": "Esqueceu-se da sua palavra-passe?",
    "CREATE_NEW_ACCOUNT": "Criar nova conta",
    "SUBMIT": "Iniciar sessão",
    "SAML": {
      "LABEL": "Login via SSO",
      "TITLE": "Initiate Single Sign-on (SSO)",
      "SUBTITLE": "Enter your work email to access your organization",
      "BACK_TO_LOGIN": "Login via Password",
      "WORK_EMAIL": {
        "LABEL": "Work Email",
        "PLACEHOLDER": "Enter your work email"
      },
      "SUBMIT": "Continue with SSO",
      "API": {
        "ERROR_MESSAGE": "SSO authentication failed. Please check your credentials and try again."
      }
    }
  }
}
